import {
  GET_GROW_NETWORK_STATS,
  GET_GROW_NETWORK_CONTACTS,
  SET_GROW_NETWORK_LOADING,
  CLEAR_GROW_NETWORK_CONTACTS,
} from "../actionTypes/growNetwork";

const initialState = {
  stats: null,
  contacts: null,
  loading: false,
};

const growNetworkReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROW_NETWORK_STATS:
      return { ...state, stats: action.payload };
    case GET_GROW_NETWORK_CONTACTS:
      return { ...state, contacts: action.payload };
    case SET_GROW_NETWORK_LOADING:
      return { ...state, loading: action.payload };
    case CLEAR_GROW_NETWORK_CONTACTS:
      return { ...state, contacts: null };
    default:
      return state;
  }
};

export default growNetworkReducer;
